package twist.mena.sports.shared.dto.ads

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class UpdateAdRequest(
    @SerialName("ad_type") val adType: String? = null,
    @SerialName("ad_location") val adLocation: String? = null,
    @SerialName("ios_ad_id") val iosAdId: String? = null,
    @SerialName("android_ad_id") val androidAdId: String? = null
)
